import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { FontWeights } from "@flat-ui";
import { useMemo } from "react";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Shows a squared avatar that can render only one letter.
 * It is mainly used to show the first letter of a company.
 *
 * @returns React company avatar component.
 */
export function CompanyAvatar(t0) {
  const $ = _c(16);
  const {
    name,
    color,
    size
  } = t0;
  let t1;
  bb0: {
    switch (size) {
      case "small":
        {
          let t2;
          if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              width: "20px",
              height: "20px",
              fontSize: "13px",
              fontWeight: "500"
            };
            $[0] = t2;
          } else {
            t2 = $[0];
          }
          t1 = t2;
          break bb0;
        }
      case "large":
        {
          let t2;
          if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              width: "24px",
              height: "24px",
              fontSize: "15px",
              fontWeight: FontWeights.SemiBold
            };
            $[1] = t2;
          } else {
            t2 = $[1];
          }
          t1 = t2;
          break bb0;
        }
      case "x-large":
        {
          let t2;
          if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              width: "32px",
              height: "32px",
              fontSize: "20px",
              fontWeight: FontWeights.SemiBold
            };
            $[2] = t2;
          } else {
            t2 = $[2];
          }
          t1 = t2;
          break bb0;
        }
    }
    t1 = undefined;
  }
  const cssProperties = t1;
  let t2;
  if ($[3] !== color || $[4] !== cssProperties.fontSize || $[5] !== cssProperties.fontWeight || $[6] !== cssProperties.height || $[7] !== cssProperties.width) {
    t2 = {
      width: cssProperties.width,
      height: cssProperties.height,
      textAlign: "center",
      display: "flex",
      textAlignLast: "center",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: color,
      color: PALETTE_VARS.common.white,
      fontSize: cssProperties.fontSize,
      fontWeight: cssProperties.fontWeight,
      borderRadius: "4px"
    };
    $[3] = color;
    $[4] = cssProperties.fontSize;
    $[5] = cssProperties.fontWeight;
    $[6] = cssProperties.height;
    $[7] = cssProperties.width;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = name[0] ?? "";
  let t4;
  if ($[9] !== t3) {
    t4 = t3.toLocaleUpperCase();
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <Box component="div"><var>{t4}</var></Box>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <Box component="div" style={t2}>{t5}</Box>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}